export const catTipoCompra = {
    NoAplica: 0,
    Reserva: 1,
    Aereo: 2,
    Liquidacion: 3,
    Seguro: 4,
    Equipaje: 5,
    UTILIDAD: 6,
}